import { Injectable, Injector } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { BaseService } from '../shared/services/base.service';
import { Faturamento } from '../models/faturamento.model';
import { Page } from '../models/page.model';
import { FaturamentoPreDefinido } from '../models/faturamento-pre-definido.model';
import { FaturamentoPreDefinidoDetalhe } from '../models/faturamento-pre-definido-detalhe.model';

@Injectable({
  providedIn: 'root'
})
export class FaturamentoService extends BaseService<Faturamento> {

  constructor(protected injector: Injector) {
    super(`${environment.API_PRICE}/faturamento`, injector);
  }

  getByEstimativa(estimativaId: number): Observable<Page<Faturamento>> {
    return this.http.get<Page<Faturamento>>(`${environment.API_PRICE}/faturamento/GetByEstimativaId/${estimativaId}`);
  }

  recalcularFaturamento(estimativaId: number) {
    return this.http.get(`${environment.API_PRICE}/faturamento/recalcular-faturamento/${estimativaId}`);
  }

  carregarListaFaturamentoPreDefinido(usuario: number, ativo: number = 1): Observable<Page<FaturamentoPreDefinido>> {
    return this.http.get<Page<FaturamentoPreDefinido>>(`${environment.API_PRICE}/faturamento/pre-definido/${usuario}/${ativo}`);
  } 1

  getPreDefinido(id: number): Observable<FaturamentoPreDefinido> {
    return this.http.get<FaturamentoPreDefinido>(`${environment.API_PRICE}/faturamento/pre-definido/byid/${id}`);
  }

  addFaturamentoPreDefinido(faturamento: FaturamentoPreDefinido) {
    return this.http.post(`${environment.API_PRICE}/faturamento/pre-definido`, faturamento);
  }

  addFaturamentoPreDefinidoDetalhe(faturamento: FaturamentoPreDefinidoDetalhe) {
    return this.http.post(`${environment.API_PRICE}/faturamento/pre-definido/detalhe`, faturamento);
  }

  updateFaturamentoPreDefinido(faturamento: FaturamentoPreDefinido) {
    return this.http.put(`${environment.API_PRICE}/faturamento/pre-definido`, faturamento);
  }

  updateFaturamentoPreDefinidoDetalhe(faturamento: FaturamentoPreDefinidoDetalhe) {
    return this.http.put(`${environment.API_PRICE}/faturamento/pre-definido/detalhe`, faturamento);
  }

  updateFaturamentoEspecifico(faturamento: Faturamento) {
    // está especificado o zero na url, pois na api não há a necessidade de um id especifico. já vai ir no faturamento ele.
    return this.http.put(`${environment.API_PRICE}/faturamento/0`, faturamento);
  }
  deleteFaturamentoPreDefinido(id: number) {
    return this.http.delete(`${environment.API_PRICE}/faturamento/pre-definido/${id}`);
  }

  deleteFaturamentoPreDefinidoDetalhe(id: number) {
    return this.http.delete(`${environment.API_PRICE}/faturamento/pre-definido/detalhe/${id}`);
  }

}
